import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';
import { omit } from 'lodash';
import { useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';
import { SendEventWrapper } from 'shared/lib/sendGAEvents';
import { useUpdateStateBySelector } from 'shared/lib/useUpdateStateBySelector';

import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';
import { setPledgeEstateInfo, PledgeEstateValidationSchema } from 'entities/pledgeEstateForm';

import { formDataSelector } from 'features/PledgeEstateForm/lib';
import { PledgeEstateFormTexts } from 'features/PledgeEstateForm/PledgeEstateForm.texts';

import { PledgeEstateFormViewHoc } from './FormBody';
import { FormFieldsControls } from './PledgeEstateForm.config';

type Props = Omit<IFormPopup, 'stepIndex' | 'setHeader' | 'isFormForceOpened' | 'onFormSubmit'> & {
  submitButtonText?: string;
  onFormSubmit?: (data: TPledgeEstateFields) => void;
};

export const PledgeEstateForm: FC<Props> = (props) => {
  const { submitButtonText, onFormSubmit, isLoading } = props;
  const [formData] = useUpdateStateBySelector(formDataSelector);
  const dispatch = useAppDispatch();

  const sendAnalyticsEvent = useCallback((_: IAnalyticsEventFormField) => {
    // todo: отправка события в аналитику
  }, []);

  const handleData = async (actualData: TPledgeEstateFields, type: string) => {
    // убираем лишние поля, которые нужны только для валидации
    const data = omit(actualData, ['mobilePhone', 'workPhone']) as TPledgeEstateFields;
    if (type === 'fullFilled') {
      dispatch(setPledgeEstateInfo({ data, isFullFilled: true }));
      onFormSubmit?.(data);
    }
  };

  return (
    <SendEventWrapper sendEvent={sendAnalyticsEvent}>
      <PledgeEstateFormViewHoc
        onDataChanged={handleData}
        defaultData={formData}
        validationSchema={PledgeEstateValidationSchema()}
        formLabels={PledgeEstateFormTexts}
        formFieldsControls={FormFieldsControls}
        submitButtonText={submitButtonText}
        isLoading={isLoading}
      />
    </SendEventWrapper>
  );
};
